import type { FaireProductEntity } from "../../entity_types/product";

export const p_gecdv9gntv: FaireProductEntity = {
  token: "p_gecdv9gntv",
  type: "product",
  name: "STRIPE PANTS",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/ea87ef7eb76b14f2ef3c1434513c47b7a2280dd6214fd56b11c41c64364afe87.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/186d64a12865b154eae2056da0cf2f707fdff0cda978f0d8bce3c5eecdc780b3.jpeg",
    "https://cdn.faire.com/fastly/042891ac211c8da93dfc0bad4729fe807b0e328838ea57b589e4b5141e71a6f0.jpeg",
    "https://cdn.faire.com/fastly/d2fbfcbfb3f832a127458950d52310b8d0f0c08c8c735d2020cf167c8e5c2789.jpeg",
    "https://cdn.faire.com/fastly/80ed715becd20c7f9f5de13d01df44a69d9a9bb9734e47667275303ba2ab36f8.jpeg",
    "https://cdn.faire.com/fastly/64c8236e4ca45069532992a4d0315eff0657251d3a864f7ce10dd9db50efb811.jpeg",
    "https://cdn.faire.com/fastly/7d8867e5e246e79d7b068665e38dc4e9e126fe44388493743a65810a9196c2b5.jpeg",
  ],
  priceDollars: 210,
  description:
    '\n\n**PANTS ONLY**\n\n(MATCHING SET WITH: PT7622-1)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"\n\n',
  tags: [],
  msrpDollars: 420,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:16.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
